import { AdminRoutes } from "./AdminRoutes";
import { AuthRoutes } from "./AuthRoutes";
import { MapRoutes } from "./MapRoutes";
import { StatusRoutes } from "./StatusRoutes";
import { createBrowserRouter, Navigate } from "react-router-dom";

/**
 * URL Parameters:
 *   :slug            Organization
 *   :jobNumber       Job or Facility
 *   :areaId          Area
 *   :producerViewId  Producer View
 *   :producerID      Producer
 */
export const useAppRoutes = () => {
  return createBrowserRouter([
    {
      path: "/",
      element: <Navigate to={"/map"} />,
    },
    AdminRoutes,
    AuthRoutes,
    MapRoutes,
    StatusRoutes,
  ]);
};
